module.exports = __webpack_public_path__ + "static/media/hpv4.9c8c04be.webp";